import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import {showMessage} from '../utils/message.js';
import i18n from "../i18n/index.js"

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push (location) {
    return originalPush.call(this, location).catch(err => err)
};

Vue.use(VueRouter);
//增加了字段 requireAuth 用来判断该路由是否需要登录
const routes = [
    {
        path: '/',
        redirect: '/homePage',
    },
    {
        path: '/',
        name: 'Home',
        component: Home,
        children: [
            {
                path: '/noPermission',
                name: 'noPermission',
                component: resolve => require(['../components/noPermission'], resolve),
                meta: { title: 'Error Page'}
            },
            // 首页
            {
                path: '/homePage',
                name: 'homePage',
                component: resolve => require(['../views/homePage/homePage'], resolve),
                meta: { title: '中谷外贸电商 | Zhonggu Foreign Trade'}
            },
            // 我要下单
            {
                path: '/order',
                name: 'order',
                component: resolve => require(['../views/order/order'], resolve),
                meta: { title: '中谷外贸电商 | Zhonggu Foreign Trade',keepAlive: true,requireAuth: true }
            },
            // 我要下单-订舱信息编辑
            {
                path: '/order/bookingSpace',
                name: 'order/bookingSpace',
                component: resolve => require(['../views/order/bookingSpace'], resolve),
                meta: { title: '订舱明细 | Booking Details', requireAuth: true }
            },
            // 订舱查询
            {
                path: '/booking',
                name: 'booking',
                component: resolve => require(['../views/booking/booking'], resolve),
                meta: { title: '中谷外贸电商 | Zhonggu Foreign Trade', keepAlive: true,requireAuth: true }
            },
            // 订舱查询-订舱信息编辑
            {
                path: '/booking/bookingSpace',
                name: 'booking/bookingSpace',
                component: resolve => require(['../views/booking/bookingSpace'], resolve),
                meta: { title: '订舱明细 | Booking Details', requireAuth: true }
            },
            // 提单信息-提单查询
            {
                path: '/billOfLading',
                name: 'billOfLading',
                component: resolve => require(['../views/billOfLading/billOfLading'], resolve),
                meta: { title: '中谷外贸电商 | Zhonggu Foreign Trade', keepAlive: true,requireAuth: true }
            },
            // 提单信息-提单查询-提单信息编辑
            {
                path: '/billOfLading/ladingDetails',
                name: 'billOfLading/ladingDetails',
                component: resolve => require(['../views/billOfLading/ladingDetails'], resolve),
                meta: { title: '提单明细 | B/L Details', requireAuth: true }
            },
            // 提单信息-提单查询-提单预览
            {
                path: '/billOfLading/ladingPreview',
                name: 'billOfLading/ladingPreview',
                component: resolve => require(['../views/billOfLading/ladingPreview'], resolve),
                meta: { title: '提单预览 | B/L Preview', requireAuth: true }
            },
            // 提单信息-拆并单-拆单
            {
                path: '/spliteBill',
                name: 'spliteBill',
                component: resolve => require(['../views/spliteBill/spliteBill'], resolve),
                meta: { title: '中谷外贸电商 | Zhonggu Foreign Trade', requireAuth: true}
            },
            // 提单信息-拆并单-并单
            {
                path: '/combineBill',
                name: 'combineBill',
                component: resolve => require(['../views/combineBill/combineBill'], resolve),
                meta: { title: '中谷外贸电商 | Zhonggu Foreign Trade', requireAuth: true}
            },
            // 箱管-修箱-修箱估价单-估价单明细
            {
                path: '/estimate/estimateDetails',
                name: 'estimate/estimateDetails',
                component: resolve => require(['../views/equipment/repair/estimateDetails'], resolve),
                meta: { title: '估价单明细 | Estimate Details', requireAuth: true}
            },
            // 箱管-修箱-修箱估价单
            {
                path: '/equipment/repair/estimate',
                name: 'estimate',
                component: resolve => require(['../views/equipment/repair/estimate'], resolve),
                meta: { title: '中谷外贸电商 | Zhonggu Foreign Trade', keepAlive: true,requireAuth: true}
            },
            // 箱管-修箱-第三方收退费
            {
                path: '/equipment/repair/thirdPartyCharge',
                name: 'thirdPartyCharge',
                component: resolve => require(['../views/equipment/repair/thirdPartyCharge'], resolve),
                meta: { title: '中谷外贸电商 | Zhonggu Foreign Trade', keepAlive: true,requireAuth: true}
            },
            // 箱管-滞箱费费率
            {
                path: '/equipment/demurrageRate',
                name: 'demurrageRate',
                component: resolve => require(['../views/equipment/demurrageRate'], resolve),
                meta: { title: '滞箱费费率 | Demurrage Rate', keepAlive: true, requireAuth: true}
            },
            // 跟踪-货物跟踪
            {
                path: '/cargoTrack',
                name: 'cargoTrack',
                component: resolve => require(['../views/track/cargoTrack'], resolve),
                meta: { title: '中谷外贸电商 | Zhonggu Foreign Trade', keepAlive: true }
            },
            // 跟踪-修箱报价查询
            {
                path: '/repairTrack',
                name: 'repairTrack',
                component: resolve => require(['../views/track/repairTrack'], resolve),
                meta: { title: '中谷外贸电商 | Zhonggu Foreign Trade', keepAlive: true }
            },
            {
                path: '/freeTime',
                name: 'freeTime',
                component: resolve => require(['../views/track/freeTime'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/personalInfo',
                name: 'personalInfo',
                component: resolve => require(['../views/userCenter/personalInfo'], resolve),
                meta: { title: '中谷外贸电商 | Zhonggu Foreign Trade', keepAlive: true ,requireAuth: true}
            },
            // 对账-费用确认
            {
                path: '/confirmFreight',
                name: 'confirmFreight',
                component: resolve => require(['../views/reconciliation/freightReceivable/confirmFreight'], resolve),
                meta: { title: '中谷外贸电商 | Zhonggu Foreign Trade', keepAlive: false,requireAuth: true }
            },
            // 对账-对账单管理
            {
                path: '/billsManagement',
                name: 'billsManagement',
                component: resolve => require(['../views/reconciliation/billManagement/billsManagement'], resolve),
                meta: { title: '中谷外贸电商 | Zhonggu Foreign Trade', keepAlive: true,requireAuth: true }
            },
            // 对账-对账单明细
            {
                path: '/billsDetails',
                name: 'billsDetails',
                component: resolve => require(['../views/reconciliation/billManagement/billsDetails'], resolve),
                meta: { title: '对账单明细 | SOA Details', requireAuth: true }
            },
            // 对账-发票申请
            {
                path: '/invoiceApplication',
                name: 'invoiceApplication',
                component: resolve => require(['../views/reconciliation/invoiceManagement/invoiceApplication'], resolve),
                meta: { title: '中谷外贸电商 | Zhonggu Foreign Trade', keepAlive: true,requireAuth: true }
            },
            // 对账-发票申请明细
            {
                path: '/invoiceDetails',
                name: 'invoiceDetails',
                component: resolve => require(['../views/reconciliation/invoiceManagement/invoiceDetails'], resolve),
                meta: { title: '发票明细 | Invoice Details', requireAuth: true }
            },
        ]
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

router.beforeEach((to,from,next) => {
    /* 路由发生变化修改页面title */
    if(to.meta.title){
        window.document.title = to.meta.title;
    }

    // 校验用户是否拥有
    if(sessionStorage.getItem("permissionList")){
        let hasPermission = false;
        let permissionList = JSON.parse(sessionStorage.getItem("permissionList"));
        permissionList = getAllPermissionList(permissionList);
        permissionList.forEach((func)=>{
            if(func.urlRouter == to.path){
                // 不需要登录的功能则放行，拥有权限的功能放行
                if(!func.loginRequired || func.hasPermission){
                    hasPermission = true;
                }
            }
        });

        // 单独排除掉首页和无权限页面（避免首页未赋权限导致网站首页无法显示）
        if(to.path === "/homePage" || to.path === "/noPermission"){
            hasPermission = true;
        }

        if(!hasPermission){
            // 跳转到无权限页面
            next("/noPermission");
        } else{
            next();
        }
    }else{
        next();
    }
});

function getAllPermissionList(data) {
    let allPermissionList = [];
    if(data != null || data.length){
        data.forEach((item)=>{
            // 菜单显示功能
            if(item.childrenFunctionList && item.childrenFunctionList.length){
                let childList = getAllPermissionList(item.childrenFunctionList);
                childList.forEach((item)=>{
                    allPermissionList.push(item);
                })
            } else{
                allPermissionList.push(item);
            }
            // 隐藏功能
            if(item.hideChildrenFunctionList && item.hideChildrenFunctionList.length){
                let childList = getAllPermissionList(item.hideChildrenFunctionList);
                childList.forEach((item)=>{
                    allPermissionList.push(item);
                })
            } else{
                allPermissionList.push(item);
            }
        })
    }
    return allPermissionList;
}

export default router
